import Editor from "@monaco-editor/react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import beautify from 'js-beautify';
import { useState } from 'react';
import { usePython } from 'react-py';
import useCodeEditorStore from '../store/codeEditorStore';
import { addHTMLtoPython, updatePythonCode } from '../utils';




function CodeBlock() {
  const [open, setOpen] = useState(false)
  const [openWarning, setOpenWarning] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [lastRun, setLastRun] = useState("")
  const { code, setCode, handleSaveCode, htmlCode, setHtmlCode, initialCode, initialHtml } = useCodeEditorStore()
  function handleEditorChange(value, event) {
    setCode(value)
  }

  const { runPython, stdout, stderr, isLoading, isRunning } = usePython()

  const handleCodeCheck = async () => {
    if (htmlCode == "") {
      setErrorMessage("HTML content cannot be empty")
      setOpenWarning(true)
      return
    }
    if (code == "") {
      setErrorMessage("Code cannot be empty")
      setOpenWarning(true)
      return
    }
    if (code == initialCode && htmlCode == initialHtml) {
      setErrorMessage("No modification present in code")
      setOpenWarning(true)
      return
    }

    if ((stdout == "" && stderr == "") || stdout == "[]") {
      setErrorMessage("Output cannot be empty, please run code first and try again")
      setOpenWarning(true)
      return
    }
    if (stderr != "") {
      setErrorMessage("Code contains some error, please modify code and try again")
      setOpenWarning(true)
      return
    }
    if (lastRun != code) {
      setErrorMessage("Code modified since last run, please run first and try again")
      setOpenWarning(true)
      return
    }
    setOpen(true)

  }


  return (
    <>

      <Box py={1} style={{ display: "flex" }}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item lg={7} md={8} sm={12} xs={12}>
            <Box style={{ width: "100%" }}>
              <Box py={1}>
                <Typography variant='h5' className='col1 card_title'>HTML :</Typography>
              </Box>
              <Editor
                height="442px"
                defaultLanguage="html"
                defaultValue={htmlCode}
                onChange={(value, event) => setHtmlCode(value)}
                options={{
                  minimap: {
                    enabled: false  // Disable the minimap
                  }
                }}
              />
            </Box>
          </Grid>
          <Grid item lg={5} md={4} sm={12} xs={12}>
            <Box style={{ width: "100%" }}>
              <Box py={1}>
                <Typography variant='h5' className='col1 card_title'>Code :</Typography>
              </Box>
              <Editor
                height="280px"
                defaultLanguage="python"
                defaultValue={code}
                onChange={handleEditorChange}
                options={{
                  minimap: {
                    enabled: false  // Disable the minimap
                  }
                }}
              />
              <Box py={1} pt={2}>
                <Typography variant='h5' className='col1 card_title'>Output :</Typography>
              </Box>
              <Editor
                height="120px"
                defaultLanguage="json"
                value={stdout != "" ? beautify.js(stdout, {
                  indent_size: 2,  // Set indentation size
                  space_in_empty_paren: true, // Add space inside empty parentheses
                }) : stderr}
                options={{
                  minimap: {
                    enabled: false  // Disable the minimap
                  }
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box mt={1}>
        <Divider />
        <Box py={2}>
          {isLoading ?
              <Box className="al_center">
                <Button disabled={true}>Preparing</Button>
              </Box>
            :
              <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={"center"}>
                <Button
                  onClick={(e) => {
                    setLastRun(code)
                    runPython(addHTMLtoPython(updatePythonCode(code), htmlCode))
                  }}
                  autoFocus
                  className="approve_btn"
                  disabled={isLoading || isRunning}
                >
                  {!isRunning ? "Run" : "Running"}
                </Button>
                <Button
                  onClick={() => {
                    handleCodeCheck()
                  }}
                  autoFocus
                  className="cancel_btn"

                >
                  Save
                </Button>
              </Stack>}
        </Box>
      </Box>


      <Box className="data preview">
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box py={2}>

                <Box className="al_center">
                  <Typography variant='h6' className='col1 card_title'>Do you want to save the changes?</Typography>
                </Box>

                <Box mt={2}>
                  <Box>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={1}>
                      <Button
                        onClick={() => {
                          // handleSaveCodeHtml(htmlCode, JSON.parse(localStorage.getItem("session")).employeeCode)
                          handleSaveCode(code, JSON.parse(localStorage.getItem("session")).employeeCode)

                          setOpen(false)
                        }}
                        autoFocus
                        className="approve_btn"
                      >
                        Yes
                      </Button>

                      <Button
                        onClick={() => {
                          setOpen(false)
                        }}
                        autoFocus
                        className="cancel_btn"
                      >
                        No
                      </Button>
                    </Stack>
                  </Box>
                </Box>

              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>

      <Box className="data preview">
        <Dialog
          open={openWarning}
          onClose={() => setOpenWarning(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" py={3}>
                <Box pb={2}>
                  <Typography className='col1 card_title'>
                    {errorMessage}
                  </Typography>
                </Box>

                <Box>
                  <Button
                    onClick={() => {
                      setOpenWarning(false)
                    }}
                    autoFocus
                    className="approve_btn"
                  >
                    Ok
                  </Button>

                </Box>

              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>

    </>
  );
}

export default CodeBlock;
